const API = {
  SUBMODAL_URL: "https://subm-api.bairuhatech.com/",
  DIGITALTWIN_URL: "https://aas-api.bairuhatech.com/",
  SEARCH_ANALYTIC_URL:"https://api-hoppe-ship-dt.bairuhatech.com/api/",
  // SEARCH_ANALYTIC_URL:"http://localhost:1337/api/",
  // SUBMODAL_URL: "https://subm-api-dev.bairuhatech.com/", //development
  // DIGITALTWIN_URL: "https://aas-api-dev.bairuhatech.com/", //development

  GET_SUBMODELS: "submodels", //GET
  ADD_SUBMODELS: "submodels", // POST

  GET_TWIN: "shells", //GET
  ADD_TWIN: "shells", //POST

  GET_SEARCH_TWIN:"digitaltwins",//GET
  GET_KIND:"kinds",
  GET_CATEGORY:"categories",
  GET_SUPPLIER:"suppliers"
};
export default API;
